import { INITIALIZE_VALUES } from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default (values) => createProjectModalActions[INITIALIZE_VALUES](values);
